<template>
    <b-row class="mb-5">
        <b-col md="12">
          <div class="pt-2 pb-2 float-right">
            <a variant="light" style="margin-top:-100px!important; margin-right:10px!important;" class="btn-back btn-custom"></a>
          </div>
          <paginated-table ref="dataTable" :can-edit="false" :can-delete="false" :can-approve="false" :can-reject="false" :can-show="true" :can-show-route-path="'#/reports/vehicle'" :can-edit-modal="false" :can-paid="false" v-on:editData="doEdit" :data-url="apiUrl.vehicleRequest" :data-key="dataKey" :data-columns="columns">
          </paginated-table>
        </b-col>
      <type-vehicle-modal ref="typeVehicleModal" :type-vehicle="'User History'" v-on:getVehicleBill="getVehicleBill"></type-vehicle-modal>
      <!-- <edit-road-tax-modal ref="editRoadTax" v-on:getVehicleBill="getVehicleBill"></edit-road-tax-modal> -->
    </b-row>
</template>
<script>
  import PaginatedTable from '@/components/PaginatedTable'
  import TypeVehicleModal from './TypeVehicleModal'
  // import EditRoadTaxModal from './EditRoadTaxModal'
  export default {
    props: {
      vehicleUuid: {
        type: String,
        required: false
      }
    },
    components: {
      PaginatedTable,
      TypeVehicleModal
      // EditRoadTaxModal
    },
    data () {
        return {
            dataKey: "vehicleRequest",
            type: "UserHistory",
            isLoading: false,
            apiUrl: {
                vehicleRequest: window.AppConfig.apiUrl + 'vehicle-request?vehicle_uuid=' + this.vehicleUuid + '&status=Finished',
                vehicleBill: window.AppConfig.apiUrl + 'vehicle-bill-info?vehicle_uuid=' + this.vehicleUuid + '&type=User History',
            },
            columns: [
                {
                  label: 'Requested By',
                  key: 'requestedByEmployee',
                  sortable: false
                },
                {
                  key: 'note',
                  sortable: false
                },
                {
                  key: 'createdAt',
                  label: 'Created',
                  sortable: false
                },
                {
                  key: 'status',
                  sortable: false
                },
                {
                  key: 'actions',
                  label: '',
                  sortable: false
                }
            ],
            vehicleRequestList: []
        }
    },
    methods: {
        getVehicleBill () {
            this.isLoading = true
            this.$refs.dataTable.getDataTable()
        },
        getDateTime (value) {
            if (value !== null) {
                return this.$moment(value).format('YYYY-MM-DD HH:mm A')
            } else {
                return '-'
            }
        },
        doModal () {
          this.$refs.typeVehicleModal.showModal()
        },
        doEdit (row) {
          this.$refs.editRoadTax.showModal(row)
        },
        doShowModal (row) {
          this.$refs.editRoadTax.showModal(row)
        },
    }
  }
</script>